<div class="unauthorized-container">
  <div class="card unauthorized">
    <div class="card-header">
      <img src="../../../../assets/images/unath.png">
    </div>
    <div class="card-body">
      <h4 class="card-title">{{unAuthorizedUserMessage}}</h4>
      <h6  *ngIf="userPermission">You do not have authorization to access this application, please contact user administrator.</h6>
      <a (click)="onLogout()" class="btn btn-primary">Log In</a>
    </div>
  </div>
</div>